import React, {useRef} from 'react';
import Navbar from "../Navbar/Navbar";
import classes from './Cone.module.scss'
import Fotter from "../Fotter/Fotter";
import {Carousel} from "antd";

function Cone() {
    const carouselRef = useRef(null);

    return (<div>

            <div className={classes['aw-container']}>
                <Navbar/>
                <div className={classes['aw-section-one']}>
                    <h3>AWC1</h3>
                    <div className={classes['aw-image']}></div>
                </div>
                <div className={classes['sections']}>
                    <div className={classes[['sections-child']]}>
                        <div className={classes['child-img']}></div>
                        <h2>Range</h2>
                        <p>10 km</p>

                    </div>
                    <div className={classes[['sections-child']]}>
                        <div className={classes['weight-img']}></div>
                        <h2>Weight</h2>
                        <p>7 kg</p>
                    </div>
                    <div className={classes[['sections-child']]}>
                        <div className={classes['time-img']}></div>
                        <h2>Flight time</h2>
                        <p>20-30 min</p>
                    </div>
                    <div className={classes[['sections-child']]}>
                        <div className={classes['altitude-img']}></div>
                        <h2>Maximum altitude</h2>
                        <p>4000 m</p>
                    </div>
                    <div className={classes[['sections-child']]}>
                        <div className={classes['speed-img']}></div>
                        <h2>Speed</h2>
                        <p>Up to 50 km/h</p>
                    </div>
                    <div className={classes[['sections-child']]}>
                        <div className={classes['payload-img']}></div>
                        <h2>Payload</h2>
                        <p>2 kg</p>
                    </div>
                    <div className={classes[['sections-child']]}>
                        <div className={classes['lunch-img']}></div>
                        <h2>Launch</h2>
                        <p>Vtol</p>
                    </div>
                    <div className={classes[['sections-child']]}>
                        <div className={classes['landing-img']}></div>
                        <h2>Max. wind speed</h2>
                        <p>30 km/h</p>
                    </div>

                </div>
                <div className={classes['paragraph-section']}>
                    <div className={classes['p-Container']}>
                        <h2 className={classes['h']} style={{fontSize: '34px', marginTop: '40px'}}> Key Features</h2>

                        <p><ul><li>
                            Vertical takeoff and landing allows the UAV to
                            be used in almost any terrain.
                            Secure radio communication.
                        </li></ul>
                                <br/>
                              <ul><li>
                                  The simplicity of the design allows us to produce
                                  a large number of products in the shortest
                                  possible time and without complex equipment.
                                  High load capacity in its class.
                              </li></ul>
                                <br/>
<ul><li>
    Folding beams allow you to significantly reduce
    dimensions during transportation.
</li></ul>
                                </p>



                        <div className={classes['paragraph-small-container']}>
                            {/*<div className={classes['paragraph-small']}>KEY FEATURES</div>*/}
                            {/*<div className={classes['paragraph-small']}>KEY FEATURES</div>*/}
                        </div>


                    </div>
                </div>


                <div
                    style={{width: '80%', height: '55vh', margin: 'auto', marginBottom: '350px', position: 'relative'}}>
                    {/* Navigation Buttons */}
                    <button
                        onClick={() => carouselRef.current?.prev()}
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: 10,
                            transform: 'translateY(-50%)',
                            fontSize: '24px',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '50%',
                            width: '40px',
                            height: '40px',
                            cursor: 'pointer',
                            zIndex: 1
                        }}
                    >
                        &#60;
                    </button>
                    <button
                        onClick={() => carouselRef.current?.next()}
                        style={{
                            position: 'absolute',
                            top: '50%',
                            right: 10,
                            transform: 'translateY(-50%)',
                            fontSize: '24px',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '50%',
                            width: '40px',
                            height: '40px',
                            cursor: 'pointer',
                            zIndex: 1
                        }}
                    >
                        &#62;
                    </button>

                    {/* Carousel */}
                    <Carousel ref={carouselRef} autoplay dots={true}>
                        <div>
                            <img src="https://i.imgur.com/Yw16b8D.png" alt="slide 1"
                                 style={{width: '100%', height: 'auto'}}/>
                        </div>
                        <div>
                            <img src="https://i.imgur.com/fipY5s0.png" alt="slide 2"
                                 style={{width: '100%', height: 'auto'}}/>
                        </div>
                        <div>
                            <img src="https://i.imgur.com/Yw16b8D.png" alt="slide 3"
                                 style={{width: '100%', height: 'auto'}}/>
                        </div>
                    </Carousel>

                    {/* IGES Viewer */}
                </div>


                <div className={classes['product-section']}>
                    <span>AWC1 - DATA SHEET</span>
                    <a
                        href='https://drive.google.com/uc?export=download&id=1nxhvxOQd0bkILiPN9FaimGerEEyvO2QJ'
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <button>Download</button>
                    </a>
                </div>
                <Fotter/>
            </div>


        </div>

    );
}

export default Cone;
